export enum RecursoSegurancaMetodo {
  POST =  'POST',
  GET = 'GET',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
  TODOS = 'TODOS',
  NAO_SE_APLICA = 'NAO_SE_APLICA'
}

